import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '@/components/Layout';
import RoofInsulationPage from '@/components/roof-insulation/RoofInsulationPage';

const RoofInsulation = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta name="description" content="Cavity Wall Insulation" />
      </Helmet>
      <Layout title="EPC Builder Cavity Wall Insulation">
        <RoofInsulationPage />
      </Layout>
    </>
  );
};

export default RoofInsulation;
